<div class="card-base">
    <div class="card-content-search">
        <div class="card-container">
            <div class="clearfix">
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-extraccionista-filter #filters></app-extraccionista-filter>
                </div>
                <div class="pull-right">
                    <mat-form-field>
                        <mat-select [(value)]="workstationSelected" placeholder="Box">
                            <mat-option *ngFor="let workstation of workstations" [value]="workstation">
                                {{ workstation }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button (click)="logOut()" mat-icon-button>
            <mat-icon>logout</mat-icon>
          </button>
                </div>

            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <mat-spinner *ngIf="loading"></mat-spinner>
                <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
                    <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="Disability">
                            <th style="width: 100px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="" #resColDisability></resizable-column-control>
                            </th>
                            <td style="width: 100px" (click)="startAttention(element)" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>
                                    <mat-icon *ngIf="
                      element.DisabilityPermanent || element.DisabilityTemporal
                    ">accessible</mat-icon>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="ReceptionDate">
                            <th style="width: 60px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="40" tile="Recepción" #resColReceptionDate></resizable-column-control>
                            </th>
                            <td style="width: 60px" (click)="startAttention(element)" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>{{ element.ReceptionHour }}</div>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="Protocol">
                            <th style="width: 100px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Protocolo" #resColProtocol></resizable-column-control>
                            </th>
                            <td style="width: 100px" (click)="startAttention(element)" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>{{ element.Protocol }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="PatientDocument">
                            <th style="width: 100px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Documento" #resColProtocol></resizable-column-control>
                            </th>
                            <td style="width: 100px" (click)="startAttention(element)" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>{{ element.Document }}</div>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="PatientAge">
                            <th style="width: 100px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="100" tile="Edad" #resColProtocol></resizable-column-control>
                            </th>
                            <td style="width: 100px" (click)="startAttention(element)" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>{{ element.PatientYearOld }}</div>
                            </td>
                        </ng-container>



                        <ng-container matColumnDef="PatientFullName">
                            <th style="width: 230px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="230" tile="Paciente" #resColPatientFullName></resizable-column-control>
                            </th>
                            <td (click)="startAttention(element)" style="width: 230px" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>{{ element.PatientFullName }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CallerNumber">
                            <th style="width: 230px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="230" tile="Nro. Llamador" #resColPatientFullName></resizable-column-control>
                            </th>
                            <td (click)="startAttention(element)" style="width: 230px" [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <div>{{ element.CallerNumber }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Call">
                            <th style="width: 230px" class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                                <resizable-column-control width="230" tile="" #resColPatientFullName></resizable-column-control>
                            </th>
                            <td [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <button [disabled]="element.Loading" mat-button color="primary" (click)="patientCall(element)">
                  <span> {{ getPatientCallButtonText(element) }} </span>
                </button>
                            </td>
                        </ng-container>

                        <!-- Star Column -->
                        <ng-container matColumnDef="Star" stickyEnd>
                            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
                            <td [ngClass]="{
                  'no-reserved': element.CanStartAttention,
                  'search-table-cell': true
                }" mat-cell *matCellDef="let element">
                                <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>

                                <button *ngIf="!element.Loading" mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                                <mat-menu #menuItem="matMenu">
                                    <button mat-menu-item (click)="openMedicalAppointmentObservationDialog(element)">
                    <mat-icon>search</mat-icon><span>Ver observaciones</span>
                  </button>

                                    <button *ngIf="element.CanRollBack" mat-menu-item (click)="rollBackAttention(element)">
                    <mat-icon>undo</mat-icon><span>Revertir</span>
                  </button>

                                    <button *ngIf="canStartAttention(element)" mat-menu-item (click)="startAttention(element)">
                    <mat-icon>flag</mat-icon><span>Iniciar atención</span>
                  </button>


                                    <button mat-menu-item (click)="openLaboratoryAppointmentQuestionDialog(element)">
                    <mat-icon>help</mat-icon><span>Preguntas laboratorio</span>
                  </button>




                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row [ngClass]="{
                'no-reserved': row.CanStartAttention,
                'search-table-cell': true
              }" *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </p-scrollPanel>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>